/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiAssignCaseRequest
 */
export interface InternalApiAssignCaseRequest {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAssignCaseRequest
     */
    assigneeId: number;
}

/**
 * Check if a given object implements the InternalApiAssignCaseRequest interface.
 */
export function instanceOfInternalApiAssignCaseRequest(value: object): value is InternalApiAssignCaseRequest {
    if (!('assigneeId' in value) || value['assigneeId'] === undefined) return false;
    return true;
}

export function InternalApiAssignCaseRequestFromJSON(json: any): InternalApiAssignCaseRequest {
    return InternalApiAssignCaseRequestFromJSONTyped(json, false);
}

export function InternalApiAssignCaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAssignCaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assigneeId': json['assigneeId'],
    };
}

export function InternalApiAssignCaseRequestToJSON(json: any): InternalApiAssignCaseRequest {
    return InternalApiAssignCaseRequestToJSONTyped(json, false);
}

export function InternalApiAssignCaseRequestToJSONTyped(value?: InternalApiAssignCaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assigneeId': value['assigneeId'],
    };
}

